import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import { meta } from 'helpers/decorators'
import AssessorsListAll from '../Assessors/AssessorsListAll'

@meta({
  title: 'Assessors',
  intlKey: 'pageTitle.assessors',
  dynamicProp: 'organizations.detail.name'
})
class AwardUnitAssessors extends Component {
  static propTypes = {}

  render() {
    return <AssessorsListAll decoFilter="onlyForOrganization" {...this.props} />
  }
}

export default AwardUnitAssessors
